// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__DQ1ty","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__1LxMd"};